import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { LazyHorizontalNavQueue } from '@jira/navigation-apps__horizontal-nav-jsm-queue/src/async-for-paint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmCustomQueueCalendarRoute } from '@jira/router-routes__servicedesk-queue-routes/src/csmCustomQueueCalendarRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { shouldLoadUIFBoardResources } from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { getCalendarFilterFieldsResource } from '@jira/router-resources__service-desk-calendar/src/useCalendarFilterResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { CalendarSkeleton, calendarPageEntryPoint } from './ui/calendar/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const csmCustomQueueCalendarRouteEntry: Route = createEntry(
	csmCustomQueueCalendarRoute,
	() => ({
		group: 'customer-service',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdCsmApp,
		},

		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? calendarPageEntryPoint
				: notFoundPageEntrypoint;
		},

		afterPaint: [LazyHorizontalNavQueue],

		forPaint: [LazyAtlassianNavigation],

		skeleton: CalendarSkeleton,

		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getQueuesResources(),
			getConsolidationStateResource(),
			getCalendarFilterFieldsResource(),
			resourceWithCondition(shouldLoadUIFBoardResources, uifBoardResource),
		],

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
